// extracted by mini-css-extract-plugin
export default {"customCheckbox":"RemoveCheckbox_customCheckbox__h6rP7","cssLabel":"RemoveCheckbox_cssLabel__W3il6"};